// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2zv_l","checkbox":"Label_checkbox__18ckj","radiobutton":"Label_radiobutton__1l5SC","toggle":"Label_toggle__28kdG"};